import React from 'react';
import FeatureCards from "../../../components/FeatureCards/FeatureCards";
import CTA from "../../../components/Constant/cta/CTA";
import TimelineSection from "../../../components/TimelineSection/TimelineSection";
import WhySection from "../../../components/WhySection/WhySection";
import LocationTimeline from "../../../components/LocationTimeline/LocationTimeline";
import IntroSection from "../../../components/IntroSection/IntroSection";
import FAQList from "../../../components/Constant/FAQCard/FAQCard";
import Testimonials from "../../../components/Constant/Testimonials/Testimonials";
import DetailsSection from "../../../components/DetailsSection/DetailsSection";
import InfoBlocks from "../../../components/InfoBlocks/InfoBlocks";
import ServiceCards from "../../../components/ServiceCards/ServiceCards ";

export default function InsuranceReinsuranceLicenseCyprus() {

    return (
        <main className='main'>

            <IntroSection
                title="Establish Your Insurance Company with EU Passporting Rights"
                subtitle=""
                description="
                <b>Cyprus</b> is a respected <b>EU hub</b> for <b>insurance and reinsurance businesses</b>, operating under the <b>Solvency II Directive</b>. Companies licensed in Cyprus can provide insurance services across the entire <b>European Economic Area (EEA)</b> via <b>passporting rights</b>.
                <br/>
                With a combination of <b>low corporate tax (12.5%)</b>, <b>EU recognition</b>, and a <b>strategic location</b>, Cyprus has become a preferred destination for <b>insurance groups</b>, <b>captives</b>, and <b>reinsurers</b> seeking <b>cost-effective EU entry</b>.
                "
                badges={
                    [
                        "Captive Insurance",
                        "General Insurance",
                        "Reinsurance",
                        "Cross-Border EU Insurance"
                    ]
                }
                buttonText="Request a Cyprus Insurance Proposal →"
                buttonLink="/quote"
                imageSrc={require("../../../assets/images/services/insurance-reinsurance-cyprus-hero.png")}
                imageAlt=""
            />

            <section className='section'>
                <div className="container">

                    <WhySection
                        title='Why Choose Cyprus for Insurance?'
                        blocks={
                            [
                                {
                                    items:
                                        [
                                            {
                                                text: "EU Recognition — full Solvency II compliance with EU passporting rights."
                                            },
                                            {
                                                text: "Trusted Regulators — ICCS and CySEC oversight ensure credibility."
                                            },
                                            {
                                                text: "Attractive for Captives — lower entry barriers compared to Luxembourg."
                                            },
                                            {
                                                text: "Tax Benefits — 12.5% corporate tax and double taxation treaties."
                                            },
                                            {
                                                text: "Reinsurance Opportunities — growing hub for EU and international reinsurers."
                                            },
                                            {
                                                text: "Strategic Location — access to EU, MENA, and Asia from one jurisdiction."
                                            }
                                        ]
                                }
                            ]
                        }
                    />

                    <InfoBlocks
                        title="Types of Insurance & Reinsurance Licenses"
                        blocks={
                            [
                                {
                                    title: "Insurance License (Life & Non-Life)",
                                    items:
                                        [
                                            {
                                                title: "Life Insurance",
                                                text: "Personal and group life insurance policies."
                                            },
                                            {
                                                title: "Non-Life Insurance",
                                                text: "Property, casualty, liability, marine, aviation, and health insurance."
                                            },
                                            {
                                                title: "Captive Insurance",
                                                text: "Corporations insuring their own risks through captive structures."
                                            }
                                        ]
                                },
                                {
                                    title: "Reinsurance License",
                                    items:
                                        [
                                            {
                                                title: "Full Reinsurance",
                                                text: "Traditional reinsurance companies offering global coverage."
                                            },
                                            {
                                                title: "Captive Reinsurance",
                                                text: "Reinsurance structures used by corporations to manage internal risk."
                                            },
                                            {
                                                title: "Alternative Risk Transfer (ART)",
                                                text: "Innovative reinsurance models, including multi-jurisdictional and hybrid structures."
                                            }
                                        ]
                                },

                            ]
                        }
                    />

                    <LocationTimeline
                        title="Capital Requirements (Solvency II)"
                        item={
                            [
                                {
                                    title: "Life Insurance",
                                    text: "€3,700,000 minimum capital requirement."
                                },
                                {
                                    title: "Non-Life Insurance",
                                    text: "€3,700,000 minimum capital requirement."
                                },
                                {
                                    title: "Captive Insurance",
                                    text: "€2,500,000 minimum capital requirement."
                                },
                                {
                                    title: "Reinsurance Companies",
                                    text: "€3,600,000 minimum capital requirement."
                                }
                            ]
                        }
                    />

                    <FeatureCards
                        title='Benefits of a Cyprus Insurance License'
                        features={
                            [
                                {
                                    title: "EEA Passporting",
                                    text: "Operate across all EU and EEA markets with a single license."
                                },
                                {
                                    title: "Solvency II Alignment",
                                    text: "Fully compliant with EU regulatory and solvency frameworks."
                                },
                                {
                                    title: "Banking Access",
                                    text: "Achieve easier onboarding and partnerships with EU financial institutions."
                                },
                                {
                                    title: "Captive & Niche Models",
                                    text: "Ideal jurisdiction for group captives and specialized insurance structures."
                                },
                                {
                                    title: "Cost Advantage",
                                    text: "Lower setup and operational costs than Malta, Luxembourg, or Dublin."
                                }
                            ]
                        }
                    />

                    <ServiceCards
                        title='Licensing Process'
                        services={
                            [
                                {
                                    title: "Consultation & Structuring",
                                    text: "Define your insurance or reinsurance model and regulatory strategy."
                                },
                                {
                                    title: "Entity Incorporation",
                                    text: "Establish a Cyprus insurance company with the required corporate structure."
                                },
                                {
                                    title: "Application Submission",
                                    text: "Submit business plan, solvency projections, and risk management policies."
                                },
                                {
                                    title: "Regulatory Review",
                                    text: "Cyprus regulator conducts fit & proper checks for shareholders and directors."
                                },
                                {
                                    title: "Approval & Licensing",
                                    text: "Licensing process typically takes 9–12 months from submission."
                                }
                            ]
                        }
                    />

                    <TimelineSection
                        title='Timeline & Costs'
                        items={
                            [
                                {
                                    name: "Timeline",
                                    duration: "9–12 months.",
                                },
                                {
                                    name: "Setup Costs",
                                    description: "from €120,000+ (legal, actuarial, compliance)."
                                },
                                {
                                    name: "Capital Requirement",
                                    description: "€2.5M–€3.7M depending on license type."
                                },
                                {
                                    name: "Annual Costs",
                                    description: "audits, actuarial reporting, ICCS supervision fees."
                                },

                            ]
                        }
                    />

                    <DetailsSection
                        title='Why Offshore Advisory?'
                        items={
                            [
                                {
                                    text: "Experts in EU insurance & reinsurance licensing."
                                },
                                {
                                    text: "Full support: incorporation, actuarial plans, license filing, compliance."
                                },
                                {
                                    text: "Guidance on captive structures, Solvency II reporting, and reinsurance networks."
                                },
                                {
                                    text: "Balanced advice: Cyprus vs Malta vs Offshore solutions."
                                },
                                {
                                    text: "Long-term support for compliance, audits, and renewals."
                                }
                            ]

                        }/>

                    <FAQList data={faqData} title='Frequently Asked Questions (FAQ)'/>

                    <Testimonials
                        title="Client Testimonials"
                        testimonials={testimonialsData}
                    />

                    <CTA
                        title="Looking to establish an EU insurance or reinsurance company?"
                        description="Cyprus offers Solvency II licensing, EU passporting, and cost efficiency for insurers, captives, and reinsurers."
                        buttonText="Book a Cyprus Insurance Consultation →"
                        buttonLink="/quote"
                    />
                </div>
            </section>
        </main>
    );
};
const testimonialsData = [
    {
        quote: "We structured our captive insurer in Cyprus. Offshore Advisory guided us through Solvency II and actuarial compliance.",
        author: "George A.",
        role: "Corporate Risk Manager"
    },
    {
        quote: "Our reinsurance company setup in Cyprus was efficient. Offshore Advisory made the MFSA process smooth.",
        author: "Anna K.",
        role: "Reinsurance Director"
    }
];

const faqData = [
    {
        question: "What makes Cyprus attractive for insurers?",
        content: [
            { type: "answer", text: "Lower cost base, EU passporting, and a 12.5% corporate tax rate." },
        ],
    },
    {
        question: "Can a Cyprus insurance company operate across the EU?",
        content: [
            { type: "answer", text: "Yes — Solvency II licensing gives EEA passporting rights." },
        ],
    },
    {
        question: "What is the capital requirement?",
        content: [
            { type: "answer", text: "€2.5M (captives) to €3.7M (life, non-life, reinsurance)." },
        ],
    },
    {
        question: "How long does licensing take?",
        content: [
            { type: "answer", text: "Typically 9–12 months." },
        ],
    },
    {
        question: "Is Cyprus better than Malta for insurance?",
        content: [
            { type: "answer", text: "Both offer Solvency II licenses, but Cyprus is cheaper and faster, while Malta has more reputation in captives." },
        ],
    },
];

